<template>
  <b-card v-if="!!option" id="page-company-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.typeCompanies.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('companySize'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('companySize'))"
                  label-for="companySize"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="companySize"
                    v-model="companieType.idCatSize"
                    :options="listCatSizes"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :placeholder="$t(label('companySize'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.companySize.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('activity'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('activity'))"
                  label-for="activity"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="activity"
                    v-model="companieType.idCatActivity"
                    :options="listCatActivitys"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :placeholder="$t(label('activity'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.activity.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('area_operation'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('area_operation'))"
                  label-for="areaOperation"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="areaOperation"
                    v-model="companieType.idCatGeographicAreaOfOperation"
                    :options="listCatGeographic"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :placeholder="$t(label('area_operation'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.areaOperation.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('ownership_company'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('ownership_company'))"
                  label-for="ownershipCompany"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="ownershipCompany"
                    v-model="companieType.idCatCompanyOwnership"
                    :options="listCatCompany"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :placeholder="$t(label('ownership_company'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.ownershipCompany.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('coin_type'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('coin_type'))"
                  label-for="coinType"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="coinType"
                    v-model="companieType.idCatCoinType"
                    :options="listCoinTypes"
                    label="name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :placeholder="$t(label('coin_type'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                    <span
                      slot="no-options"
                      click="$refs.coinType.open = false"
                      >{{ $t("sorryOption") }}</span
                    >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('companyContext'))"
                label-for="companyContext"
              >
                <b-form-textarea
                  id="companyContext"
                  v-model="companieType.businessContext"
                  :placeholder="$t(label('companyContext'))"
                  :disabled="!isSaveMode"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col
              class="mt-3 d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, integer } from "@validations";
import vSelect from "vue-select";

import {
  getCompanieType,
  createOrEditCompanieType,
} from "@core/api/request/companiesTypes";
import { getCatalog } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

const companieType = {
  idCompanyType: null,
  guid: null,
  idCatSize: 0,
  idCatActivity: 0,
  idCatGeographicAreaOfOperation: 0,
  idCatCompanyOwnership: 0,
  idCatCoinType: 0,
  businessContext: null,
};

export default {
  components: {
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BFormSelect,
    BToast,
    BFormInvalidFeedback,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    isSaveMode: true,
    required,
    companieType: Object.assign(companieType),
    listCatSizes: [],
    listCatActivitys: [],
    listCatGeographic: [],
    listCatCompany: [],
    listCoinTypes: [],
    itemsPage: 1,
    itemsRows: 999,
    option: null,
  }),
  computed: {},

  created() {
    localize("es");
    this.loadCatData();
  },

  mounted() {
    this.initialize();
  },
  methods: {
    label(field) {
      return `pages.typeCompanies.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "companiesTypes" }).catch(() => {});
      }
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            router.push({ name: "companiesTypes" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          this.showCompanieType(this.$route.params.guid);
          break;
      }
    },

    chargeParams(key) {
      let arrParams = [];

      arrParams.push(`itemsPage,${this.itemsPage}`);

      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "catalog":
          arrParams.push("guidCatalog, 6e66d474-5417-436a-8f56-3186d97f6173");
          break;
        case "activity":
          arrParams.push("guidCatalog, e1a80765-e23a-4627-b0e9-9fa95f376726");
          break;
        case "geographicArea":
          arrParams.push("guidCatalog, 0cdd192f-9e6c-4c1b-bff9-ded669f36bca");
          break;
        case "ownerships":
          arrParams.push("guidCatalog, 95da642c-78ad-4365-9410-ca2996bd3f3f");
          break;
        case "coinTyps":
          arrParams.push("guidCatalog, 20ce3c04-4594-4398-adae-f8def7bd8f25");
          break;
      }

      return getParams(arrParams);
    },

    async loadCatData() {
      showLoading();
      try {
        const paramSizes = this.chargeParams("catalog");
        const paramActivitys = this.chargeParams("activity");
        const paramGeographicArea = this.chargeParams("geographicArea");
        const paramOwnerships = this.chargeParams("ownerships");
        const paramCoinTyps = this.chargeParams("coinTyps");
        const [
          resultSizes,
          resultActivitys,
          resultGeographicArea,
          resultOwnerships,
          resultCoinTyps,
        ] = await Promise.all([
          getCatalog(paramSizes),
          getCatalog(paramActivitys),
          getCatalog(paramGeographicArea),
          getCatalog(paramOwnerships),
          getCatalog(paramCoinTyps),
        ]);
        stopLoading();
        this.listCatSizes = _.get(resultSizes, "data.listOfItems.items");
        this.listCatActivitys = _.get(
          resultActivitys,
          "data.listOfItems.items",
        );
        this.listCatGeographic = _.get(
          resultGeographicArea,
          "data.listOfItems.items",
        );
        this.listCatCompany = _.get(resultOwnerships, "data.listOfItems.items");
        this.listCoinTypes = _.get(resultCoinTyps, "data.listOfItems.items");
      } catch (error) {
        console.log("error", error);
        stopLoading();
        this.alertToast("danger", `Alerta codigo`, error.message);
      }
    },

    showCompanieType(guid) {
      showLoading();
      getCompanieType(guid)
        .then((resp) => {
          const companieType = _.get(resp, "data");
          this.companieType = Object.assign(this.companieType, {
            guid: companieType.guid,
            idCompanyType: companieType.idCompanyType,
            idCatSize: companieType.idCatSize,
            idCatActivity: companieType.idCatActivity,
            idCatGeographicAreaOfOperation:
              companieType.idCatGeographicAreaOfOperation,
            idCatCompanyOwnership: companieType.idCatCompanyOwnership,
            idCatCoinType: companieType.idCatCoinType,
            businessContext: companieType.businessContext,
          });
          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    onSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();
          createOrEditCompanieType(this.companieType, this.companieType.guid)
            .then(() => {
              stopLoading();
              this.alertToast("success", "Registro exitoso");
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.alertToast("danger", "Alerta error", error.message);
            });
        }
      });
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      Object.assign(this.companieType, {
        idCompanyType: null,
        guid: null,
        idCatSize: 0,
        idCatActivity: 0,
        idCatGeographicAreaOfOperation: 0,
        idCatCompanyOwnership: 0,
        idCatCoinType: 0,
        businessContext: null,
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
